import { render, staticRenderFns } from "./4_2_m_contributionPostDetail.vue?vue&type=template&id=c9b91ab4&scoped=true&"
import script from "./4_2_m_contributionPostDetail.vue?vue&type=script&lang=js&"
export * from "./4_2_m_contributionPostDetail.vue?vue&type=script&lang=js&"
import style0 from "./4_2_m_contributionPostDetail.vue?vue&type=style&index=0&id=c9b91ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b91ab4",
  null
  
)

export default component.exports